import React, {
  Fragment,
  useRef,
  useState,
  useContext,
  createContext,
  useEffect,
} from "react";
import { motion, AnimatePresence, useAnimation } from "framer-motion";
import CodeEditor from "@uiw/react-textarea-code-editor";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Table,
  Badge,
  Dropdown,
  ProgressBar,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import {
  useTable,
  useGlobalFilter,
  useFilters,
  usePagination,
} from "react-table";
import loadingCircleImg from "../../../../images/misc/loading-circle-green.svg";
import landmarkImg from "../../../../images/landmark/logo-text-dark.png";
import ApiService from "../../../../services/ApiService";
import PageHeaderBar from "../../../layouts/PageHeaderBar";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import PersonIcon from "@mui/icons-material/Person";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { styled } from "@mui/material/styles";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { utils } from "ethers";
import { MaterialReactTable } from "material-react-table";
import { ExportToCsv } from "export-to-csv";
import { ExportJsonCsv } from "react-export-json-csv";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { FileCopyOutlined as FileCopyOutlinedIcon } from "@mui/icons-material";
import DoneIcon from "@mui/icons-material/Done";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { darken } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { TypeAnimation } from "react-type-animation";
import {
  areSetsEqual,
  copyTextToClipboard,
  useDocumentTitle,
} from "../../../utils";
import { ThemeContext } from "../../../../context/ThemeContext";
import {
  addOneMonth,
  arraysAreEqual,
  epochToDateString,
  epochToDateTimeString,
  stringToRGB,
  toTitleCase,
} from "../../../../utils";
import BlueLoading from "../../../../images/misc/blue-goo-loading.svg";
import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-markup";
import "prismjs/themes/prism.css"; //Example style, you can use another
import ErrorBoundary from "../../ErrorBoundary";
import parse from 'html-react-parser';
import { useAuth } from "../../../Providers/LandmarkAuthContext";
import EmployeeInfo from "./EmployeeInfo";

const MasterEventsTable = ({
  employee,
  zoomMeetings,
  zoomMeeting,
  getZoomMeeting,
}) => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const [selectedZoomMeeting, setSelectedZoomMeeting] = useState(null);
  const [infoLoadingMeetingId, setInfoLoadingMeetingId] = useState(null);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const outputRef = useRef(null);
  const [infoHtml, setInfoHtml] = useState("");

  async function getMeetingInfo(meetingId) {
    setInfoLoadingMeetingId(meetingId);
    console.log(`getMeetingInfo() - ${meetingId}`);
    await getZoomMeeting(meetingId);
    setInfoLoadingMeetingId(null);
    setShowInfoModal(true);
  }

  useEffect(() => {
    if (zoomMeeting) {
      const htmlContent = `
      <div style="font-family: Arial, Helvetica, sans-serif; font-size: 10px; line-height: 1; color: black;">
        <b>Join Zoom Meeting:</b> <a href="${zoomMeeting.joinUrl}" style="color: blue; text-decoration: underline;">${zoomMeeting.joinUrl}</a><br>
        <b>Meeting ID:</b> ${zoomMeeting.meetingId}<br>
        <b>Passcode:</b> ${zoomMeeting.passcode}<br>
        <b>Dial in:</b> ${zoomMeeting.dialIn}<br>
        <b>Find your local number:</b> <a href="${zoomMeeting.localNumbersUrl}" style="color: blue; text-decoration: underline;">${zoomMeeting.localNumbersUrl}</a>
      </div>
    `;

      setInfoHtml(htmlContent);
    }
  }, [zoomMeeting]);

  const outputCopyText = () => {
    if (outputRef.current) {
      const blob = new Blob([infoHtml], { type: "text/html" });
      const data = [new ClipboardItem({ "text/html": blob })];

      navigator.clipboard
        .write(data)
        .then(() => {
          toast.success("Copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy content:", err);
          toast.error("Failed to copy content");
        });
    }
  };

  const ZoomMeetingModal = () => {
    if (!zoomMeeting || !showInfoModal) return null;

    return (
      <div
        className={`popup-container ${showInfoModal ? "show" : ""}`}
        style={{ maxWidth: "700px", margin: "auto" }}
      >
        <motion.div animate={{ x: 0 }} initial={{ x: 150 }}>
          <div className="result-display">
            <div className="row">
              <div className="col-6">
                <div className="subtitle">HTML</div>
                <div className="template-form">
                  <div className="row">
                    <div className="form-group mb-3 col-12">
                      <ErrorBoundary>
                        <Editor
                          value={infoHtml}
                          onValueChange={(code) => setInfoHtml(code)}
                          highlight={(code) => {
                            try {
                              return highlight(code, languages.markup);
                            } catch (error) {
                              console.error("Highlighting error:", error);
                              return code; // Return unformatted code as a fallback
                            }
                          }}
                          padding={15}
                          className="code-editor"
                          style={{
                            color: "#000",
                            fontSize: 11,
                            backgroundColor: "#fff",
                            border: "1px #0072ff solid",
                            borderRadius: "0.625rem",
                            fontFamily:
                              "ui-monospace,Roboto Mono,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
                          }}
                        />
                      </ErrorBoundary>
                    </div>{" "}
                    {/* <-- Moved this closing div here to properly close form-group */}
                  </div>{" "}
                  {/* <-- Closes .row inside .template-form */}
                </div>{" "}
                {/* <-- Closes .template-form */}
              </div>{" "}
              {/* <-- Closes .col-6 (Edit Template) */}
              <div className="col-6">
                <div className="subtitle">Output</div>
                <div className="viewer">
                  <div className="body" ref={outputRef}>
                    {parse(infoHtml)}
                  </div>
                  <div className="clipboard" onClick={outputCopyText}>
                    <i class="fa-regular fa-clipboard"></i>
                  </div>
                </div>
              </div>{" "}
              {/* <-- Closes .col-6 (Viewer) */}
            </div>{" "}
            {/* <-- Closes .row inside .result-display */}
          </div>{" "}
          {/* <-- Closes .result-display */}
        </motion.div>
      </div>
    );
  };

  // Close modal when clicking outside
  const handleOutsideClick = (e) => {
    // Check if the clicked element or any of its parents have the popup-container class
    let targetElement = e.target;
    let isPopupContainer = false;

    while (targetElement) {
      if (
        targetElement.classList &&
        targetElement.classList.contains("popup-container")
      ) {
        isPopupContainer = true;
        break;
      }
      targetElement = targetElement.parentElement;
    }

    if (!isPopupContainer) {
      setShowInfoModal(false);
    }
  };

  // Add event listener for outside clicks when modal is shown
  useEffect(() => {
    if (showInfoModal) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showInfoModal]);

  const toggleModal = () => {
    setShowInfoModal(!showInfoModal);
  };

  useEffect(() => {
    if (selectedZoomMeeting) {
      getZoomMeeting(selectedZoomMeeting);
    }
  }, [selectedZoomMeeting]);

  // const confirmBtnClicked = async () => {
  //   if (!selectedQuickbooksCustomerName) {
  //     toast.error(`Please select a Quickbooks Customer`);
  //     return;
  //   } else {
  //     const customerId = quickbooksCustomers.find(
  //       (qc) => qc.displayName === selectedQuickbooksCustomerName
  //     ).customerId;
  //     const success = await addQuickbooksCustomerSalesforceMapping(
  //       customerId,
  //       zoomMeeting.clientName
  //     );
  //     if (success) {
  //       // show success msg
  //       setShowSuccessMsg(true);
  //     }
  //   }
  // };

  if (!zoomMeetings || !zoomMeetings.length) {
    return (
      // <div className="error-msg">
      //   Could not get Zoom Meetings from server (if this problem persists please
      //   notify{" "}
      //   <a href="mailto:mjones@landmarkventures.com">
      //     mjones@landmarkventures.com
      //   </a>
      //   )
      // </div>

      <>
        <div className="text-center loading-text">Loading Zoom Meetings...</div>
        <div className="loading-container-big">
          <img src={BlueLoading} className="img-fluid" />
        </div>
      </>
    );
  }

  // if (!zoomMeeting) {
  //   return (
  //     <div className="error-msg">
  //       Could not get Invoice Opportunity from server (if this problem persists
  //       please notify{" "}
  //       <a href="mailto:mjones@landmarkventures.com">
  //         mjones@landmarkventures.com
  //       </a>
  //       )
  //     </div>
  //   );
  // }

  return (
    <>
      <ZoomMeetingModal />
      <motion.div animate={{ x: 0 }} initial={{ x: 150 }}>
        <Card className="mb-3 h-fc bot-table">
          {/* <div className="event-image-img">
              <img src={selectedInvoice.imageUrl} className="img-fluid" />
            </div> */}
          <div className="row">
            <div className="outputHeader">Zoom Meetings</div>
            <>
              <></>
              <div className="outputBody">
                <div className="table-wrapper">
                  {" "}
                  <div className="row mt-4">
                    <div className="col-12">
                      <div className="table-responsive">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>Topic</th>
                              <th>Start Time</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {zoomMeetings && zoomMeetings.length > 0 ? (
                              [...zoomMeetings]
                                .filter((m) => {
                                  if (!m.start_time) return false;
                                  const meetingDate = new Date(m.start_time);
                                  const today = new Date();
                                  today.setHours(0, 0, 0, 0); // Set to beginning of current day
                                  return (
                                    !isNaN(meetingDate.getTime()) &&
                                    meetingDate >= today
                                  );
                                })
                                .sort((a, b) => {
                                  // Check if start_time exists and is in valid format
                                  const dateA = a.start_time
                                    ? new Date(a.start_time)
                                    : null;
                                  const dateB = b.start_time
                                    ? new Date(b.start_time)
                                    : null;

                                  // Check if dates are valid
                                  if (!dateA || isNaN(dateA.getTime())) {
                                    return 1; // Move invalid dates to the end
                                  }
                                  if (!dateB || isNaN(dateB.getTime())) {
                                    return -1; // Move invalid dates to the end
                                  }

                                  // Sort by date (most recent first)
                                  return dateA - dateB;
                                })
                                .map((meeting, index) => (
                                  <tr key={index}>
                                    <td>{meeting.id}</td>
                                    <td>
                                      <b>{meeting.topic}</b>
                                    </td>
                                    <td>
                                      {meeting.start_time &&
                                      !isNaN(
                                        new Date(meeting.start_time).getTime()
                                      )
                                        ? new Date(
                                            meeting.start_time
                                          ).toLocaleString()
                                        : "Invalid date"}
                                    </td>
                                    <td>
                                      <button
                                        className="btn btn-primary btn-sm get-details-btn"
                                        onClick={() =>
                                          getMeetingInfo(meeting.id)
                                        }
                                      >
                                        {infoLoadingMeetingId === meeting.id ? (
                                          <div className="loading-container">
                                            <img
                                              src={BlueLoading}
                                              className="img-fluid"
                                            />
                                          </div>
                                        ) : (
                                          `Get Details`
                                        )}
                                      </button>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td colSpan="4" className="text-center">
                                  No meetings found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
        </Card>
      </motion.div>
    </>
  );
};

const PasswordPrompt = ({ employee, setPassword, submitPassword }) => {
  const handleInputChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await submitPassword(employee);
  };

  return (
    <div className="d-flex">
      <input
        onChange={handleInputChange}
        type="employee"
        className="form-control w-100 mt-1 inline-input"
        placeholder="Password"
        value={employee}
      ></input>
      <div
        className="btn btn-primary light btn-xs mt-1 me-1 w-fc inline-btn"
        onClick={(e) => handleSubmit(e)}
      >
        Submit
      </div>
    </div>
  );
};

const getQueryParams = (search) => {
  return new URLSearchParams(search);
};

const Dashboard = (props) => {
  const { changeBackground } = useContext(ThemeContext);
  const { employee, isAuthenticated, loading, logout } = useAuth();

  const [zoomMeeting, setZoomMeeting] = useState(null);
  const [zoomMeetings, setZoomMeetings] = useState([]);

  const query = getQueryParams(window.location.search);
  // const opportunityId = query.get("opportunity");

  // set light theme once
  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // touch lastSeenTime when authenticated (fire & forget)
  useEffect(() => {
    if (!isAuthenticated || !employee) return;
    try {
      const api = new ApiService({ employee });
      api.get("landmark/employees/login");
    } catch {
      /* noop */
    }
  }, [isAuthenticated, employee]);

  async function getZoomMeetings() {
    try {
      const api = new ApiService({ employee });
      const response = await api.get(`landmark/zoom/getMeetings`);
      setZoomMeetings(response);
    } catch (error) {
      console.error(error);
    }
  }

  async function getZoomMeeting(meetingId) {
    if (meetingId) {
      try {
        const api = new ApiService({ employee });
        const response = await api.get(`landmark/zoom/getMeeting/${meetingId}`);
        setZoomMeeting(response);
      } catch (error) {
        console.error(error);
      }
    }
  }

  // load meetings after auth
  useEffect(() => {
    if (isAuthenticated) {
      getZoomMeetings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  useDocumentTitle("Zoom Dashboard - Landmark Ventures");

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <div className="spinner-border" role="status" aria-label="Loading" />
      </div>
    );
  }

  return (
    <Fragment>
      <div className="global-dash-wrapper invoice-dash zoom-dash">
        <div className="d-flex align-items-center justify-content-center">
          <img src={landmarkImg} className="img-fluid landmark-img" alt="Landmark" />
        </div>

        {isAuthenticated && employee && (
          <div className="landmark-sign-in" style={{ marginBottom: "18px" }}>
            <div className="existing-accounts-container">
              <EmployeeInfo
                landmarkEmployee={employee}
                disableHover={true}
                showLogout={true}
                logout={logout}
              />
            </div>
          </div>
        )}

        <PageHeaderBar
          pages={[
            { title: "Landmark", url: `` },
            { title: "Zoom Dashboard", url: `/landmark/zoom/dashboard` },
          ]}
        />

        {isAuthenticated ? (
          <>
            <MasterEventsTable
              employee={employee}
              zoomMeetings={zoomMeetings}
              zoomMeeting={zoomMeeting}
              getZoomMeeting={getZoomMeeting}
            />
          </>
        ) : (
          <div className="text-center text-muted p-5">
            Please sign in to access the dashboard.
          </div>
        )}
      </div>
    </Fragment>
  );
};


export default Dashboard;
